import http from 'core/http.service';
import BaseService from 'services/BaseService';
import { Page } from 'models/page';
import { TripFeeDTO, TripFeeSearchDTO } from 'models/trip-fee';

class TripFeeService extends BaseService {
    /** 출장비 목록 조회 (관리자) */
    public list(search: TripFeeSearchDTO): Promise<Page<TripFeeDTO>> {
        return super.request(http.get('/trip-fee', search));
    }

    /** 출장비 상세 조회 */
    public get(id: number): Promise<TripFeeDTO> {
        return super.request(http.get(`/trip-fee/${id}`));
    }

    /** 출장비 저장 (신규/수정 겸용) */
    public save(dto: TripFeeDTO): Promise<TripFeeDTO> {
        return super.request(http.post('/trip-fee', dto));
    }

    /** 출장비 삭제 */
    public remove(id: number): Promise<void> {
        return super.request(http.delete(`/trip-fee/${id}`));
    }

    /** 도별 출장비 목록 조회 (선택박스용) */
    public getProvinceList(): Promise<{ province: string; baseAmount: number }[]> {
        return super.request(http.get('/trip-fee/provinces'));
    }

    /** 특정 도의 지역별 출장비 목록 */
    public getCityListByProvince(province: string): Promise<TripFeeDTO[]> {
        return super.request(http.get(`/trip-fee/provinces/${province}/cities`));
    }

    /** 출장비 일괄 등록/수정 */
    public bulkUpsert(tripFees: Partial<TripFeeDTO>[]): Promise<void> {
        return super.request(http.post('/trip-fee/bulk-upsert', tripFees));
    }

}

const tripFeeService = new TripFeeService();
export default tripFeeService;